import { AuthenticatedTemplate, useMsal } from "@azure/msal-react"
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import CheckListIcon from '@mui/icons-material/Checklist';
import React from "react"
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { profileApi } from "../../../../../services/ProfileService/profileApi";
import { useGetMyProfileQuery } from "../../../../../services/ProfileService";
import { RootState } from "../../../../../app/store";
import { hasConfigurationAccess, hasPhysicianGroupAccess } from "../../../../profile/utils/profileUtils";

function ConfigurationMenu(){
    const navigate = useNavigate();
    const { instance } = useMsal();
    const dispatch = useDispatch();
    const [open,setopen] = React.useState(false);
    const { data: myProfile, isLoading } = useGetMyProfileQuery();
    const organization = myProfile?.organization ?? '';
    const selectedCenter = useSelector((state: RootState) => state.center.selectedCenter);

    React.useEffect(() => {
        const callbackId = instance.addEventCallback((event) => {
            if (event.eventType === 'msal:loginSuccess') {
                dispatch(profileApi.util.invalidateTags(['myProfile']));
            }
        });
        return () => {
            if (callbackId) instance.removeEventCallback(callbackId);
        };
    }, [instance, dispatch]);

    return<React.Fragment>
        <AuthenticatedTemplate>
            {(hasConfigurationAccess(myProfile) || hasPhysicianGroupAccess(myProfile)) && (
                <List component='nav' sx={{border:'black solid 1px'}}>
                    <ListItemButton onClick={() => setopen(!open)}>
                        <ListItemText primary='Configuration' />
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                    {hasConfigurationAccess(myProfile) && (
                    <React.Fragment>
                    <ListItemButton sx={{marginTop:'0px'}} onClick={()=>navigate('/company')}>
                            <ListItemIcon><CheckListIcon sx={{color:'white'}}/></ListItemIcon> Company
                    </ListItemButton>
                    <ListItemButton sx={{marginTop:'0px'}} onClick={()=>navigate('/diagnosis-codes')}>
                            <ListItemIcon><CheckListIcon sx={{color:'white'}}/></ListItemIcon> Diagnosis Codes
                    </ListItemButton>
                    <ListItemButton sx={{marginTop:'0px'}} onClick={()=>organization && navigate(`/centers/${organization}`)} disabled={!organization && !isLoading}>
                            <ListItemIcon><CheckListIcon sx={{color:'white'}}/></ListItemIcon> Centers
                    </ListItemButton>
                    </React.Fragment>
                    )}
                    {hasPhysicianGroupAccess(myProfile) && (
                    <ListItemButton sx={{marginTop:'0px'}} onClick={()=>organization && navigate(`/physician-groups/${organization}`)} disabled={!organization && !isLoading}>
                            <ListItemIcon><CheckListIcon sx={{color:'white'}}/></ListItemIcon> Physician Groups
                    </ListItemButton>
                    )}
                    </Collapse>
                </List>
            )}
        </AuthenticatedTemplate>
    </React.Fragment>
}

export{ConfigurationMenu}